import { render } from "./component-reform-to.vue?vue&type=template&id=23fca834"
import script from "./component-reform-to.vue?vue&type=script&setup=true&lang=js"
export * from "./component-reform-to.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-reform-to.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23fca834"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23fca834', __exports__)) {
    api.reload('23fca834', __exports__)
  }
  
  module.hot.accept("./component-reform-to.vue?vue&type=template&id=23fca834", () => {
    api.rerender('23fca834', render)
  })

}


export default __exports__